import React from "react";
import styles from "./ReturnPoliciesPage.module.css";
import PropTypes from "prop-types";

import Typography from "@material-ui/core/Typography";

function ReturnPoliciesPage(props) {
  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <Typography variant="h4" gutterBottom>
          CHÍNH SÁCH ĐỔI SẢN PHẨM TẠI KUNLEZ:
        </Typography>
        <Typography variant="h6" gutterBottom>
          Quy định đổi hàng trong vòng 5 ngày đầu tiên sau khi mua hàng đối với
          các sản phẩm (không bao gồm sản phẩm đặt theo yêu cầu):
        </Typography>
        <Typography variant="body1" gutterBottom>
          KUNLEZ chấp nhận cho Quý khách đổi hàng Hoàn trả hàng trong vòng 5
          ngày đầu tiên sau khi mua hàng, với các điều kiện như sau:
        </Typography>
        <Typography variant="body1" gutterBottom>
          <ul>
            <li>Sản phẩm phải còn nguyên vẹn.</li>
            <li>Số lần đổi sản phẩm tối đa là 01 lần.</li>
            <li>
              Chúng tôi không nhận đổi trả các lỗi gây ra do quá trình sử dụng.
            </li>
            <li>Trả hàng trong 5 ngày đầu hoàn tiền 100%.</li>
          </ul>
        </Typography>
        <Typography variant="h6" gutterBottom>
          Ghi Chú:
        </Typography>
        <Typography variant="body1" gutterBottom>
          <ul>
            <li>
              Sản phẩm trang còn nguyên vẹn: là sản phẩm không bị móp méo, đứt,
              gãy, biến dạng, sản phẩm không bị trầy xước, bể, mẻ, nứt. Và hóa
              đơn kiêm Giấy bảo hành và Giấy kiểm định đính kèm (nếu có).
            </li>
          </ul>
        </Typography>
      </div>

      <div className={styles.item}>
        <Typography variant="h4" gutterBottom>
          Chính sách Bảo Hành Sản Phẩm:
        </Typography>
        <Typography variant="h6" gutterBottom>
          Quy định đổi hàng trong vòng 5 ngày đầu tiên sau khi mua hàng đối với
          các sản phẩm (không bao gồm sản phẩm đặt theo yêu cầu):
        </Typography>
        <Typography variant="body1" gutterBottom>
          <ul>
            <li>Hỗ trợ khai quang trì chú sản phẩm.</li>
            <li>Hỗ trợ xem ngày giờ tốt.</li>
            <li>Hỗ trợ xem hướng tốt.</li>
          </ul>
        </Typography>
      </div>
    </div>
  );
}

ReturnPoliciesPage.propTypes = {};

export default ReturnPoliciesPage;
